import React, { useState, lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import { Typography, SvgIcon } from '@mui/material';
import { ReactComponent as InfoIcon } from 'mui/assets/icons/Info-lightgrey.svg';
import { ReactComponent as CloseRoundedIcon } from 'mui/assets/icons/close-icon-rounded.svg';
import Link from 'mui/components/elements/Link';

const DS_MarkdownComponent = lazy(() => import('mui/components/elements/DS_Markdown'));

import { Banner, StyledCloseButton, StyledTextContainer, StyledWrapper } from './styles';

const NewsBanner = ({ newsBanner, alert = false, overWriteBackColor = false }) => {
  const { link, text, backgroundColor, textColor, impress, BFstyles, gradientBackgroundOption } = newsBanner;

  const [isBannerVisible, setIsBannerVisible] = useState(() => {
    const sessionStorageBannerValue = window.sessionStorage.getItem(`news-banner-${newsBanner.id}`);
    return sessionStorageBannerValue !== 'hidden';
  });

  const hideNewsBanner = () => {
    try {
      window.sessionStorage.setItem(`news-banner-${newsBanner.id}`, 'hidden');
    } catch (e) {
      console.error('sessionStorage quota exceeded.', e);
      sessionStorage.clear();
      window.sessionStorage.setItem(`news-banner-${newsBanner.id}`, 'hidden');
    }

    setIsBannerVisible(false);
  };

  const markdownText = text?.markdown.html;

  return isBannerVisible ? (
    <Banner
      id={`news-banner-${newsBanner.id}`}
      data-test="news-banner"
      alert={alert}
      overWriteBackColor={overWriteBackColor}
      backgroundColor={backgroundColor}
      textColor={textColor}
      impress={impress}
      $BFstyles={BFstyles}
      $gradientBackgroundOption={gradientBackgroundOption}
    >
      <StyledWrapper>
        {markdownText && (
          <StyledTextContainer impress={impress}>
            {impress && !BFstyles && <SvgIcon component={InfoIcon} inheritViewBox={true} />}
            <Suspense fallback={<p></p>}>
              <DS_MarkdownComponent $BFstyles={BFstyles}>{markdownText}</DS_MarkdownComponent>
            </Suspense>
          </StyledTextContainer>
        )}
        {link ? (
          <Link url={link.url}>
            <Typography component="span" variant="DS_copySmallBold">
              {link.title}
            </Typography>
          </Link>
        ) : null}
      </StyledWrapper>
      <StyledCloseButton onClick={hideNewsBanner} alert={alert} impress={impress} className="close-button">
        <SvgIcon component={CloseRoundedIcon} viewBox="0 0 24 24" />
      </StyledCloseButton>
    </Banner>
  ) : null;
};

NewsBanner.propTypes = {
  newsBanner: PropTypes.shape({
    link: PropTypes.object,
    backgroundColor: PropTypes.string,
    textColor: PropTypes.string,
    impress: PropTypes.bool,
    BFstyles: PropTypes.bool,
    gradientBackgroundOption: PropTypes.string,
  }),
};

export default NewsBanner;
